export enum CardType {
    Unknown,
    Amex
}